/* eslint-disable no-restricted-globals */
import { position } from 'caret-pos';

import { fieldErrors } from './errors';

/**
 * @param {HTMLElement} field
 * @param {FieldState} fieldState
 */
export function addFieldListeners(field, fieldState, form) {
  const { blur, change, focus } = fieldState;

  const blurHandler = e => blur(e);

  field.addEventListener('input', event => change(event.target.value));
  field.addEventListener('blur', blurHandler);
  field.addEventListener('focus', () => focus());
}

const cacheFields = {};

/**
 * Safari reactive input carret fix
 * @param {Function} update
 * @param {HTMLElement} field
 * @param {FieldState} fieldState
 */
function updateWithCarretPosition(update, field, fieldState) {
  const ignoreFields = ['checkbox', 'select', 'select-one', 'hidden'];
  const { active } = fieldState;

  let carretPosition = NaN;

  if (ignoreFields.includes(field.type)) {
    update();
    return;
  }

  if (active) {
    carretPosition = position(field).pos;
  }

  update();

  if (active && !isNaN(carretPosition)) {
    position(field, carretPosition);
  }
}

/**
 * Render
 * @param {HTMLElement} field
 * @param {FormApi} form
 * @returns {Unregister} unregister
 */
export function registerField(field, form) {
  const { name } = field;

  return form.registerField(
    name,
    fieldState => {
      const { value } = fieldState;

      if (!cacheFields[field.name]) {
        cacheFields[field.name] = true;
        addFieldListeners(field, fieldState, form);
      }

      updateWithCarretPosition(
        () => {
          field.value = value === undefined ? '' : value;
        },
        field,
        fieldState,
      );

      fieldErrors(field, fieldState);
    },
    {
      active: true,
      value: true,
      error: true,
      touched: true,
      submitError: true,
      dirtySinceLastSubmit: true,
    },
  );
}
